import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/useUser'

const generateTabBarItems = (user) => {
  const urls = generateUrls(user)
  const { editUserUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editUserUrl,
      key: 'details',
      title: user?.full_name || 'User Details',
    },
  ]
}

export default generateTabBarItems
